import React from 'react';
import { Link } from 'react-router-dom';

export default function DeveloperPlatform() {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center'
    }}>
      <h1>Coming Soon</h1>
      <p>
        <Link to="/">Retour à l'accueil</Link>
      </p>
    </div>
  );
}
